import React, { useState, useEffect } from 'react';
import './CustomCheckbox.css';

const CustomCheckbox = ({ label, onChange, checked }) => {
  const [isChecked, setIsChecked] = useState(checked || false);

  // Обновляем локальный стейт, если проп checked изменился извне
  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleCheckboxChange = () => {
    const newCheckedState = !isChecked;
    setIsChecked(newCheckedState);

    if (onChange) {
      onChange(newCheckedState); // Вызываем onChange, если он передан
    }
  };

  return (
    <div className='custom-checkbox'>
      <label className='custom-checkbox__label'>
        <span className='custom-checkbox__input'>
          <span
            className={`custom-checkbox__inner ${
              isChecked ? 'custom-checkbox__inner--checked' : ''
            }`}
          ></span>
          <input
            type='checkbox'
            className='custom-checkbox__original'
            checked={isChecked}
            onChange={handleCheckboxChange}
            aria-hidden='false'
          />
        </span>
        {label && <span className='custom-checkbox__text'>{label}</span>}
      </label>
    </div>
  );
};

export default CustomCheckbox;
